import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import { useWindowWidth } from "@react-hook/window-size";
import downArrow from "./assets/downArrow.svg";
import {
  Seccion,
  ImageProfile,
  FlexColumn,
  NombreApellido,
  Cargo,
  StatusConnectUser,
  ContentImageProfile,
  FlexRow2,
  FlexRow,
  Container,
  Icon,
  Dropdown
} from "./stylesNavbarHorizontal"

const NavbarHorizontal = ({ user }) => {
  const navigate = useNavigate();
  const onlyWidth = useWindowWidth();
  const location = useLocation();
  const params = useParams();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const initial = user?.name ? user?.name.charAt(0).toUpperCase() : '?';

  const logoutHandler = () => {
    console.log('Logout');
    localStorage.removeItem('user');
    navigate("/login");
  };

  return (
    <Container>
      <FlexRow onlyWidth={onlyWidth}>
        <Seccion>
          {location.pathname === "/" && "Inicio"}
          {location.pathname === "/contacts" && "Contactos"}
          {location.pathname === "/productores" && "Productores"}
          {location.pathname === "/contacts" + '/' + params?.id && "Contactos"}
          {location.pathname === "/asesores" && "Asesores"}
          {location.pathname === "/asesores" + '/' + params?.id && "Asesores"}
          {location.pathname === "/seguimientos" && "Seguimientos"}
          {location.pathname === "/seguimientos" + '/' + params?.id && "Seguimientos"}
          {location.pathname === "/clientes" && "Clientes"}
          {location.pathname === "/clientes" + '/' + params?.id && "Clientes"}
          {location.pathname === "/agenda" && "Agenda"}
          {location.pathname === "/organizaciones" && "Organizaciones"}
          {location.pathname === "/opciones" && "Preferencias"}
        </Seccion>
        <FlexRow2>
          <ContentImageProfile>
            <ImageProfile backgroundColor={"#003049"}>
              {initial}
            </ImageProfile>
            <StatusConnectUser status={true} />
          </ContentImageProfile>
          <FlexColumn>
            <NombreApellido>
              {user?.name?.toUpperCase()} {user?.lastname?.toUpperCase()}
            </NombreApellido>
            <Cargo>
              {user?.type?.toUpperCase()}
            </Cargo>
          </FlexColumn>
          <Icon onClick={() => setOpen(!open)} open={open} src={downArrow} />

          <Dropdown ref={dropdownRef} open={open}>
            {
              onlyWidth < 1100 ?
                <>
                  <Link onClick={() => setOpen(!open)} to="/contacts">Contactos</Link>
                  <Link onClick={() => setOpen(!open)} to="/seguimientos">Seguimientos</Link>
                  <Link onClick={() => setOpen(!open)} to="/clientes">Clientes</Link>
                  <Link  onClick={() => setOpen(!open)}to="/asesores">Asesores</Link>
                  <Link onClick={() => setOpen(!open)} to="/productores">Productores</Link>
                  <Link onClick={() => setOpen(!open)} to="/agenda">Agenda</Link>
                  <Link onClick={() => setOpen(!open)} to="/opciones">Preferencias</Link>
                </> : null
            }
            <Link target="_blank" to={'https://wa.link/iez0it'}>Soporte</Link>
            <Link onClick={() => setOpen(!open)} to={'/profile'}>Mi cuenta</Link>
            <button type="button" onClick={logoutHandler}>Cerrar sesión</button>
          </Dropdown>
        </FlexRow2>
      </FlexRow>
    </Container>
  );
};

export default NavbarHorizontal;
